import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { IDynamicElement, ILink, Image, ImageData, ImageDataDb, IInfoBubble, IMediaItem, GridComponent, LinkDirective, HeadingComponent, TextHtmlComponent, ButtonComponent, IconComponent } from '@sirius/common';

import {
    BundleItem,
    ButtonCommerce,
    ProductHeaderCommerce,
    Weight,
    ExternalLink,
} from 'commerce/models';
import { StoreExperienceTypes } from 'shared/constants';
import { Router } from '@angular/router';
import { ProductImageSliderComponent } from '../product-image-slider/product-image-slider.component';
import { BundleItemComponent } from '../bundle-item/bundle-item.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'commerce-product-header-commerce',
    templateUrl: './product-header-commerce.component.html',
    styleUrls: ['./product-header-commerce.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GridComponent, ProductImageSliderComponent, LinkDirective, HeadingComponent, TextHtmlComponent, ButtonComponent, BundleItemComponent, IconComponent, TranslatePipe]
})
export class ProductHeaderCommerceComponent implements IDynamicElement, OnInit {
    private _router = inject(Router);

    @Input()
    title = '';

    @Input()
    subTitle? = '';

    @Input()
    brand?: string;

    @Input()
    textHtml?: string = '';

    @Input()
    mediaItems?: IMediaItem[];

    @Input()
    buttonPrimary?: ButtonCommerce;

    @Input()
    buttonSecondary?: ButtonCommerce;

    @Input()
    infoBubble?: IInfoBubble;

    @Input()
    logo?: Image;

    @Input()
    netWeight?: Weight;

    @Input()
    sku?: string;

    @Input()
    longDescription?: string;

    @Input()
    externalLinks?: ExternalLink[];

    @Input()
    config?: ProductHeaderCommerce;

    @Input()
    children?: BundleItem[];

    @Input()
    storeExperienceType?: StoreExperienceTypes;

    @Input()
    partnerPageLink?: ILink;

    imageData?: ImageData;

    storeExperienceTypeEnum = StoreExperienceTypes;

    private hasMediaSlider = false;


    ngOnInit(): void {
        if (this.config) {
            this.title = this.config.title;
            this.subTitle = this.config.subTitle;
            this.textHtml = this.config.textHtml ?? '';
            this.mediaItems = this.config.mediaItems;
            this.buttonPrimary = this.config.buttonPrimary;
            this.buttonSecondary = this.config.buttonSecondary;
            this.infoBubble = this.config.infoBubble;
            this.logo = this.config.logo;
            this.netWeight = this.config.netWeight;
            this.sku = this.config.sku;
            this.longDescription = this.config.longDescription;
            this.children = this.config.children;
            this.externalLinks = this.config.externalLinks;
            this.storeExperienceType = this.config.storeExperienceType;
            this.brand = this.config.brand;
            this.partnerPageLink = this.config.partnerPageLink;
        }

        this.imageData = ImageDataDb.productHeader;
    }

    get uniqueManufacturers() {
        if (!this.children) return [];
        const manufacturerMap = new Map();
        this.children
            .map((children) => children.product)
            .forEach((child) => {
                if (child.manufacturer) {
                    manufacturerMap.set(child.manufacturer.name, child.manufacturer);
                }
            });
        return Array.from(manufacturerMap.values());
    }

    get _cleanUrl() {
        const currentUrl = this._router.url;
        return currentUrl.split('#')[0];
    }

    getTabsLink(): ILink {
        return {
            title: 'Description',
            href: this._cleanUrl,
            anchor: 'anchor-tabs',
        };
    }

    handleExternalLinkClick(link: ExternalLink): ILink {
        const href = link.externalLink.startsWith('http')
            ? link.externalLink
            : `https://${link.externalLink}`;

        return {
            title: 'Website',
            href: href,
            target: '_blank',
            noRouting: true,
            rel: 'noopener noreferrer',
        };
    }

    getFormLink(): ILink {
        return {
            title: 'Request information',
            href: this._cleanUrl,
            anchor: 'anchor-form',
        };
    }
}
